  <div class="container-fluid grey-bg form-wrapper thankyou-wrapper">
    <div class="row">
      <div class="col-12">
        <div class="form-box text-center">
          <div class="top-detail">
            <a href="/" title="Back to Home"><img alt="world of sweets logo" src="../../assets/images/bonds-logo.svg" /></a>
          </div>
          <img alt='svg' src="/assets/images/no-result.svg"/>
          <h2>Payment Failed</h2>
          <p class="max-340">
            Your Order has not been completed.
          <p>
            <button routerLink="/mycart"  type="submit" class="btn primary-btn">Go Back To My Cart</button>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>